import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';
import config from 'config';
import IndexLayer from 'components/IndexLayer';
import LoginCheckLayer from 'components/LoginCheckLayer';
import Login from 'pages/Login';
import BaseRouter from './BaseRouter';
import InitialPage from './InitialPage';
import Notfound from './Notfound';
import Base from 'components/Base';

class IndexRouter extends React.Component{

    componentDidCatch(){
        this.setState({ hasError: true });
    }

    render() {
        const IndexLayerWithExteriorRoute = ({ component: Component, ...rest }) => (
            <Route {...rest} render={props => (
                <Base {...props}>
                    <IndexLayer {...props}>
                        <InitialPage {...props} {...rest}>
                            <Component {...props} />
                        </InitialPage>
                    </IndexLayer>
                </Base>
            )} />
        );
        const LoginRoute = ({ component: Component, ...rest }) => {
            return (
                <Route exact {...rest} render={props => (
                    <Base {...props}>
                        <LoginCheckLayer isAdmin={rest.isAdmin}>
                            <Component {...props} />
                        </LoginCheckLayer>
                    </Base>
                )} />
            );
        };

        const NotMustLoginRoute = ({ component: Component, ...rest }) => {
            return (
                <Route exact {...rest} render={props => (
                    <LoginCheckLayer notMust={true}>
                        <Component {...props} />
                    </LoginCheckLayer>
                )} />
            );
        };
        return(
            <Router basename={config.basename}>
                <Switch>
                    {/* <IndexLayerWithExteriorRoute path='/forget-password' component={ForgetPassword} />
                    <IndexLayerWithExteriorRoute path='/reset-password-faceid' component={ResetPasswordOld} /> */}
                    <IndexLayerWithExteriorRoute path='/login' component={Login} />
                    {/* <IndexLayerWithExteriorRoute path='/verify/:token' component={SecoundVerify} /> */}
                    <LoginRoute path='/pages' component={BaseRouter} />;
                    <NotMustLoginRoute component={Notfound}/>
                    {/* <Route component={SpecialNoFound} />; */}
                </Switch>
            </Router>
        );
    }
}

export default IndexRouter;



// WEBPACK FOOTER //
// ./src/pages/IndexRouter.js